module.exports = __webpack_public_path__ + "static/media/user_icon.e1e8225a.svg";